export const QUOTATION_PREVIEW_BASE_PATH = "/quotation/preview"

export const buildQuotationPreviewPath = (quotationId: string | number): string =>
	`${QUOTATION_PREVIEW_BASE_PATH}/${encodeURIComponent(String(quotationId))}`
